module.exports = __webpack_public_path__ + "img/Nedbank.bdc7baf7.svg";